export default () => Component(function ($context) {
	return $context.select('.fixed-bar');
}, function ($fixedBar, self) {

	const _private = {
		handleCartUpdate: function (e, response) {
			if (response.status !== 'ok') {
				return;
			}

			const data = response.data || {};
			const count = data.count || 0;

			self.changeCartCount(count);
		},

		initEventListeners: function () {
			$(document).on('shop_cart_add', this.handleCartUpdate);
			$(document).on('shop_cart_update', this.handleCartUpdate);
			$(document).on('shop_cart_delete', this.handleCartUpdate);
			$(document).on('shop_cart_clear', this.handleCartUpdate);
		}
	};

	$.extend(self, {

		handleCatalogBtn: function () {
			const $catalogBtn = $fixedBar.find('.fixed-bar__item_catalog');
			const $catalogModal = $('.modal-catalog');

			$catalogModal.on('modal_opened', function () {
				$catalogBtn.addClass('fixed-bar__item_active');
			});
			$catalogModal.on('modal_closed', function () {
				$catalogBtn.removeClass('fixed-bar__item_active');
				$catalogModal.removeClass('modal--fixed-bar');
			});
		},
		changeCartCount: function (count) {
			count = +count;

			const $countBlock = $fixedBar.find('.fixed-bar__item-count_cart');
			$countBlock.html(count);
			$countBlock.toggleClass('fixed-bar__item-count_empty', count === 0);
		},

		hideMenuForKeyboard: function () {
			let originalPotion = false;
			$(document).ready(function(){
				if (originalPotion === false) originalPotion = $(window).width() + $(window).height();
			});

			const $menuBlock = $fixedBar.find('.fixed-bar__menu');

			if (ResponsiveUtil.getMobileOperatingSystem() !== 'ios') {
				$(window).on('resize orientationchange', function(){
					if (originalPotion !== false) {
						const diff = Math.abs(originalPotion - ($(window).width() + $(window).height()));
						const toHideMenu = diff > 100;

						$menuBlock.toggleClass('fixed-bar__menu_hidden', toHideMenu);
						$('.to-cart__buy--fixed').toggle(!toHideMenu);
						JivoWidget.changeJivoBtnPosition();
					}
				});
			}
		},
	});

	self.handleCatalogBtn();
	self.hideMenuForKeyboard();
	_private.initEventListeners();
})
